module.exports = __webpack_public_path__ + "img/horizontal_4_7_pp12_8003.09469438.png";